module.exports = __webpack_public_path__ + "img/wechat.c4986409.jpg";